import axios from 'axios';
import { AwsWafError } from 'errors/AwsWafError';
import { WAF_VALIDATE_ENDPOINT_LIST } from 'config/app-config';

import type { InternalAxiosRequestConfig } from 'axios';

axios.interceptors.request.use(
  async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const shouldValidateWaf = WAF_VALIDATE_ENDPOINT_LIST.reduce((acc, url) => {
      return acc || url.test(config?.url as string);
    }, false);

    if (!shouldValidateWaf) {
      return Promise.resolve(config);
    }

    try {
      const { AwsWafIntegration } = window;

      if (AwsWafIntegration?.hasToken()) {
        return Promise.resolve(config);
      }

      await AwsWafIntegration?.getToken();
      return Promise.resolve(config);
    } catch (e) {
      const error = new AwsWafError({ error: e });
      return Promise.reject(error);
    }
  }
);

// eslint-disable-next-line no-barrel-files/no-barrel-files
export default axios;
